import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df7869a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-page" }
const _hoisted_2 = { class: "wrapper-table" }
const _hoisted_3 = { class: "wrapper-top-bar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Relatório de Clientes C4b", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ButtonDefault = _resolveComponent("ButtonDefault")!
  const _component_TableView = _resolveComponent("TableView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_ButtonDefault, {
          "v-if": _ctx.data.length > 0,
          msg: "Baixar como .csv",
          onButtonClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleDownload()))
        }, null, 8, ["v-if"])
      ]),
      (_ctx.data.length > 0)
        ? (_openBlock(), _createBlock(_component_TableView, {
            key: 0,
            columns: _ctx.tableColumns,
            data: _ctx.data
          }, null, 8, ["columns", "data"]))
        : _createCommentVNode("", true)
    ])
  ]))
}